import Container from 'containers/NewWordsFrame/Container';
import * as React from 'react';

export default {
  desktop() {
    return <Container forceMobile={false} />;
  },
  mobile() {
    return <Container forceMobile={true} />;
  },
};
